import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

function createStore() {
    return new Vuex.Store({
        state: () => ({
            isMenuOpen: false,
            status: [],
            isFiltered: false,
            isLanguageType: null,
            isProductType: null,
            additionalInformation: null,
            products: [],
            product: {},
            countries: [],
            brands: [],
            brandInReports: "",
            countriesInReports: "",
            comparisonData: null,
            CucCodePrimary: null,
            CucCodeSecondary: null,
            CucStatus: null,
            RevisionPrimary: null,
            RevisionSecondary: null,
            userRole: null,
            formulation: null,
            formulations: [],
            formulationInProduct: null,
        }),
        actions: {
            fetchStatus: ({
                commit
            }, status) => {
                commit('SET_STATUS', status)
            },
            fetchIsFiltered: ({
                commit
            }, value) => {
                commit('SET_IS_FILTERED', value)
            },
            fetchIsLanguageType: ({
                commit
            }, value) => {
                commit('SET_IS_LANGUAGE_TYPE', value)
            },
            fetchIsProductType: ({
                commit
            }, value) => {
                commit('SET_IS_PRODUCT_TYPE', value)
            },
            fetchAdditionalInformation: ({
                commit
            }, value) => {
                commit('SET_ADDITIONAL_INFORMATION', value)
            },
            updateProduct: ({
                commit
            }, product) => {
                commit('SET_UPDATE_PRODUCT', product)
            },
            fetchCountries: ({
                commit
            }, value) => {
                commit('SET_COUNTRIES', value)
            },
            addProduct: ({
                commit
            }, value) => {
                commit('SET_ADD_PRODUCT', value)
            },
            fetchProducts: ({
                commit
            }, value) => {
                commit('SET_PRODUCTS', value)
            },
            fetchCucCodePrimary: ({
                commit
            }, value) => {
                commit('SET_CUC_CODE_PRIMARY', value)
            },
            fetchCucCodeSecondary: ({
                commit
            }, value) => {
                commit('SET_CUC_CODE_SECONDARY', value)
            },
            fetchCucStatus: ({
                commit
            }, value) => {
                commit('SET_CUC_STATUS', value)
            },
            fetchRevisionPrimary: ({
                commit
            }, value) => {
                commit('SET_REVISION_PRIMARY', value)
            },
            fetchRevisionSecondary: ({
                commit
            }, value) => {
                commit('SET_REVISION_SECONDARY', value)
            },
            fetchBrandIds: ({
                commit
            }, value) => {
                commit('SET_BRAND_IDS', value)
            },
            fetchUserRole: ({
                commit
            }, value) => {
                commit('SET_USER_ROLE', value)
            },
            fetchFormulation: ({
                commit
            }, value) => {
                commit('SET_FORMULATION', value)
            },
            fetchFormulations: ({
                commit
            }, value) => {
                commit('SET_FORMULATIONS', value)
            },
            updateFormulationInProduct: ({
                commit
            }, value) => {
                commit('SET_FORMULATION_IN_PRODUCT', value)
            },
            fetchIsMenuOpen: ({
                commit
            }, value) => {
                commit('SET_IS_MENU_OPEN', value)
            },
            fetchBrandInReports: ({
                commit
            }, value) => {
                commit('SET_BRAND_IN_REPORTS', value)
            },
            fetchCountriesInReports: ({
                commit
            }, value) => {
                commit('SET_COUNTRIES_IN_REPORTS', value)
            },
        },
        mutations: {
            SET_IS_MENU_OPEN: (state, menu) => {
                state.isMenuOpen = menu;
            },
            SET_STATUS: (state, status) => {
                state.status = status;
            },
            SET_IS_FILTERED: (state, value) => {
                state.isFiltered = value;
            },
            SET_IS_LANGUAGE_TYPE: (state, value) => {
                state.isLanguageType = value;
            },
            SET_IS_PRODUCT_TYPE: (state, value) => {
                state.isProductType = value;
            },
            SET_ADDITIONAL_INFORMATION: (state, value) => {
                state.additionalInformation = value;
            },
            SET_ADD_PRODUCT: (state, value) => {
                state.products = [...value, ...state.products];
            },
            SET_UPDATE_PRODUCT: (state, value) => {
                state.product = value;
            },
            SET_COUNTRIES: (state, value) => {
                state.countries = value;
            },
            SET_PRODUCTS: (state, value) => {
                state.products = value;
            },
            SET_CUC_CODE_PRIMARY: (state, value) => {
                state.CucCodePrimary = value;
            },
            SET_CUC_CODE_SECONDARY: (state, value) => {
                state.CucCodeSecondary = value;
            },
            SET_CUC_STATUS: (state, value) => {
                state.CucStatus = value;
            },
            SET_REVISION_PRIMARY: (state, value) => {
                state.RevisionPrimary = value;
            },
            SET_REVISION_SECONDARY: (state, value) => {
                state.RevisionSecondary = value;
            },
            SET_BRAND_IDS: (state, value) => {
                state.brands = value;
            },
            SET_USER_ROLE: (state, value) => {
                state.userRole = value;
            },
            SET_FORMULATION: (state, value) => {
                state.formulation = value;
            },
            SET_FORMULATIONS: (state, value) => {
                state.formulations = value;
            },
            SET_FORMULATION_IN_PRODUCT: (state, value) => {
                state.formulationInProduct = value;
            },
            SET_BRAND_IN_REPORTS: (state, value) => {
                state.brandInReports = value;
            },
            SET_COUNTRIES_IN_REPORTS: (state, value) => {
                state.countriesInReports = value;
            },
        },
        getters: {
            GET_STATUS: state => state.status,
            GET_IS_FILTERED: state => state.isFiltered,
            GET_IS_LANGUAGE_TYPE: state => state.isLanguageType,
            GET_IS_PRODUCT_TYPE: state => state.isProductType,
            GET_ADDITIONAL_INFORMATION: state => state.additionalInformation,
            GET_PRODUCTS: state => state.products,
            GET_UPDATE_PRODUCT: state => state.product,
            GET_COUNTRIES: state => state.countries,
            GET_CUC_CODE_PRIMARY: state => state.CucCodePrimary,
            GET_CUC_CODE_SECONDARY: state => state.CucCodeSecondary,
            GET_CUC_STATUS: state => state.CucStatus,
            GET_REVISION_PRIMARY: state => state.RevisionPrimary,
            GET_REVISION_SECONDARY: state => state.RevisionSecondary,
            GET_BRAND_IDS: state => state.brands,
            GET_USER_ROLE: state => state.userRole,
            GET_FORMULATION: state => state.formulation,
            GET_FORMULATIONS: state => state.formulations,
            GET_FORMULATION_IN_PRODUCT: state => state.formulationInProduct,
            GET_IS_MENU_OPEN: state => state.isMenuOpen,
            GET_BRAND_IN_REPORTS: state => state.brandInReports,
            GET_COUNTRIES_IN_REPORTS: state => state.countriesInReports,
        }
    });
}
export default createStore